import './index.scss';
import classnames from 'classnames';
import React, { useState } from 'react';
import DataElement from './data_element';
const LeftPanel = ({ document }) => {
    const [panelCollapsed, setPanelCollapsed] = useState(false);
    const panelClass = classnames('left-panel', {
        collapsed: panelCollapsed,
    });
    const hasCategories = Object.keys(document).includes('clauses');
    return (React.createElement("div", { className: panelClass },
        React.createElement("div", { title: `${panelCollapsed ? 'Expand Panel' : 'Collapse Panel'}`, className: 'hide-icon', onClick: () => setPanelCollapsed(!panelCollapsed), "data-public": true },
            panelCollapsed && React.createElement("span", null,
                React.createElement("i", { className: 'fas fa-chevron-right' })),
            !panelCollapsed && React.createElement("span", null,
                React.createElement("i", { className: 'fas fa-chevron-left' }))),
        React.createElement("h4", { "data-public": true }, "PDF Navigation"),
        React.createElement("div", { className: 'data-elements' }, hasCategories
            ? Object.entries(document).map(entry => {
                return Object.entries(entry[1]).map(e => {
                    return React.createElement(DataElement, { category: entry[0], k: e[0], value: e[1] });
                });
            }).flat()
            : Object.entries(document).map(entry => React.createElement(DataElement, { k: entry[0], value: entry[1] })))));
};
export default LeftPanel;
